export default () => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.9173 4.54963L5.68102 14.3259C5.33227 14.6971 4.99477 15.4284 4.92727 15.9346L4.51102 19.5796C4.36477 20.8959 5.30977 21.7959 6.61477 21.5709L10.2373 20.9521C10.7435 20.8621 11.4523 20.4909 11.801 20.1084L21.0373 10.3321C22.6348 8.64463 23.3548 6.72088 20.8685 4.36963C18.3935 2.04088 16.5148 2.86213 14.9173 4.54963Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.376 6.18115C13.8597 9.28615 16.3797 11.6599 19.5072 11.9749"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.375 25.2495H23.625"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
